import type { Asset } from '@schibsted-svp/svp-api-types';
import type { ComponentChild } from 'preact';

import type { VariantAccessLevel } from '../../../../utils/player/asset';
import { getAssetAccess } from '../../../../utils/player/asset';
import { AudioNativePlayButton } from '../../components/AudioNativePlayButton/AudioNativePlayButton';
import { PaywallButtons } from '../../components/PaywallButtons/PaywallButtons';
import { Typography } from '../../components/Typography/Typography';
import { AudioPlayer } from '../AudioPlayer/AudioPlayer';
import { usePlayerError } from '../../hooks/PlayerErrorProvider';

interface PodcastControlsProps {
  isPlaying: boolean;
  hasAccess: boolean;
  asset?: Asset;
  accessLevel: ReturnType<typeof getAssetAccess> | VariantAccessLevel;
  durationInMinutes: number | null;
  onPlay: () => void;
  nativeAudioLink?: string;
  playIcon: ComponentChild;
}

export const PodcastControls = ({
  isPlaying,
  hasAccess,
  asset,
  accessLevel,
  durationInMinutes,
  onPlay,
  nativeAudioLink,
  playIcon,
}: PodcastControlsProps) => {
  const { errorDetails } = usePlayerError();

  if (isPlaying || errorDetails) {
    return <AudioPlayer />;
  }

  if (!hasAccess && asset) {
    return (
      <div className="vgp-podcast-layout-idle vgp-podcast-layout-idle-blocked">
        <PaywallButtons
          color="primary"
          size="standard"
          asset={asset}
          accessLevel={accessLevel}
          variant="podcast"
        />
      </div>
    );
  }

  return (
    <div className="vgp-podcast-layout-idle">
      <AudioNativePlayButton
        href={nativeAudioLink}
        onClick={onPlay}
        size="medium"
        className="vgp-podcast-layout-play-button"
      >
        {playIcon}
      </AudioNativePlayButton>
      {durationInMinutes !== null && (
        <Typography variant="label" size="medium" color="primary">
          {durationInMinutes} min
        </Typography>
      )}
    </div>
  );
};
